import apiClient from './client'
import type { ApiResponse } from '@portal/types'
import type { PaymentListItem } from './payments'

export interface ApprovalListResponse {
  items: PaymentListItem[]
  total: number
  page: number
  limit: number
}

export interface OTPRequestResponse {
  success: boolean
  message: string
}

export interface ApproveResult {
  newStatus: string
  utrNumber?: string
  iciciReqId?: string
  message?: string
}

export const approvalsApi = {
  list: (params?: { page?: number; limit?: number }) =>
    apiClient.get('/api/approvals', { params }) as unknown as Promise<ApiResponse<ApprovalListResponse>>,

  history: (params?: { page?: number; limit?: number }) =>
    apiClient.get('/api/approvals/history', { params }) as unknown as Promise<ApiResponse<ApprovalListResponse>>,

  pendingCount: () =>
    apiClient.get('/api/approvals/pending/count') as unknown as Promise<ApiResponse<{ count: number }>>,

  requestOTP: (id: string) =>
    apiClient.post(`/api/approvals/${id}/request-otp`) as unknown as Promise<ApiResponse<OTPRequestResponse>>,

  approve: (id: string, otp: string) =>
    apiClient.post(`/api/approvals/${id}/approve`, { otp }) as unknown as Promise<ApiResponse<ApproveResult>>,

  reject: (id: string, reason: string) =>
    apiClient.post(`/api/approvals/${id}/reject`, { reason }) as unknown as Promise<ApiResponse<unknown>>,
}
